import { tv } from 'tailwind-variants';
import { INPUT_VARIANT } from '../../utils/constant.esm.js';

const textAreaStyles = tv({
    slots: {
        root: `
      iris:flex
      iris:flex-col
      iris:gap-(--comp-space-gap-input)
      iris:bg-[transparent]
    `,
        areaWrapper: `
      iris:group
      iris:flex
      iris:flex-col
      iris:gap-(--comp-space-gap-input)
    `,
        container: `
      iris:relative
      iris:flex
      iris:h-(--base-space-px-80)
      iris:w-full
      iris:flex-col
      iris:justify-between
      iris:gap-(--comp-space-gap-input)
      iris:rounded-(--comp-size-radius-input)
      iris:border-(length:--comp-size-border-input)
      iris:border-(--comp-color-border-input-rest)
      iris:bg-(--comp-color-background-input-rest)
      iris:font-(family-name:--comp-type-font-input-value)
      iris:transition-all
      iris:duration-(--comp-motion-duration-input)
      iris:ease-(--comp-motion-easing-input)
      iris:group-hover:border-(--comp-color-border-input-hover)
      iris:group-hover:bg-(--comp-color-background-input-hover)
      iris:focus-within:border-(--comp-color-content-input-active)
      iris:focus-within:bg-(--comp-color-background-input-active)
      iris:focus-within:ring-2
      iris:focus-within:ring-(--sem-color-border-interactive-selected)
      iris:focus-within:ring-offset-2
      iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
    `,
        outerLabel: `
      iris:cursor-auto
      iris:font-(family-name:--comp-type-font-input-label)
      iris:text-(length:--comp-type-size-input-label)
      iris:leading-(--comp-type-leading-input-label)
      iris:font-(--comp-type-weight-input-label)!
      iris:tracking-(--comp-type-tracking-input-label)
      iris:text-(--comp-color-content-input-label-rest)
      iris:transition-all
      iris:duration-(--comp-motion-duration-input)
      iris:ease-(--comp-motion-easing-input)
      iris:group-focus-within:text-(--comp-color-content-input-label-active)
      iris:group-hover:text-(--comp-color-content-input-label-hover)
      iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-active)
    `,
        innerLabel: `
      iris:absolute
      iris:cursor-auto
      iris:px-(--comp-space-padding-input-horizontal)
      iris:font-(family-name:--comp-type-font-input-inner-label)
      iris:text-(length:--comp-type-size-input-value)
      iris:leading-(--comp-type-leading-input-inner-label)
      iris:font-(--comp-type-weight-input-inner-label)
      iris:tracking-(--comp-type-tracking-input-value)
      iris:text-(--comp-color-content-input-label-rest)
      iris:transition-all
      iris:duration-(--comp-motion-duration-input)
      iris:ease-(--comp-motion-easing-input)
      iris:group-focus-within:top-(--base-space-px-12)
      iris:group-focus-within:-translate-y-1/2
      iris:group-focus-within:text-(length:--comp-type-size-input-inner-label)
      iris:group-focus-within:tracking-(--comp-type-tracking-input-inner-label)
      iris:group-focus-within:text-(--comp-color-content-input-label-active)
      iris:group-hover:text-(--comp-color-content-input-label-hover)
      iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-active)
      iris:group-data-[state=has-value]:top-(--base-space-px-12)
      iris:group-data-[state=has-value]:-translate-y-1/2
      iris:group-data-[state=has-value]:text-(length:--comp-type-size-input-inner-label)
      iris:group-data-[state=has-value]:tracking-(--comp-type-tracking-input-inner-label)
    `,
        textArea: `
      iris:scrollbar-width-none
      iris:-ms-overflow-style-none
      iris:h-full
      iris:w-full
      iris:cursor-text
      iris:rounded-b-(--comp-size-radius-input)
      iris:px-(--comp-space-padding-input-horizontal)
      iris:text-(length:--comp-type-size-input-value)
      iris:leading-(--comp-type-leading-textarea-value)
      iris:font-(--comp-type-weight-input-value)!
      iris:tracking-(--comp-type-tracking-input-value)
      iris:text-(--comp-color-content-input-value-rest)
      iris:outline-none
      iris:placeholder:font-(family-name:--comp-type-font-input-placeholder)
      iris:placeholder:text-(length:--comp-type-size-input-placeholder)
      iris:placeholder:leading-(--comp-type-leading-textarea-value)
      iris:placeholder:font-(--comp-type-weight-input-inner-placeholder)
      iris:placeholder:tracking-(--comp-type-tracking-input-placeholder)
      iris:placeholder:text-(--comp-color-content-input-placeholder-rest)
      iris:group-hover:placeholder:text-(--comp-color-content-input-placeholder-hover)
      iris:[&::-webkit-scrollbar]:hidden
    `,
        errorContainer: `
      iris:h-(--comp-size-icon-input-helper)
      iris:font-(family-name:--comp-type-font-input-helper)
    `,
        errorIcon: `
      iris:size-(--base-space-px-16)
      iris:text-(--comp-color-content-input-helper-error)
    `,
        errorLabel: `
      iris:text-(length:--comp-type-size-input-helper)
      iris:leading-(--comp-type-leading-input-helper)
      iris:font-(--comp-type-weight-input-helper)!
      iris:tracking-(--comp-type-tracking-input-helper)
      iris:text-(--comp-color-content-input-helper-error)
      iris:hover:text-(--comp-color-content-input-helper-error)
    `,
        footer: `
      iris:flex
      iris:justify-between
      iris:gap-(--comp-space-gap-input-helper)
      iris:font-(family-name:--comp-type-font-input-helper)
    `,
        footerHelper: `
      iris:text-(length:--comp-type-size-input-helper)
      iris:leading-(--comp-type-leading-input-helper)
      iris:font-(--comp-type-weight-input-helper)
      iris:tracking-(--comp-type-tracking-input-helper)
      iris:text-(--comp-color-content-input-helper-default)
      iris:transition-all
      iris:duration-(--comp-motion-duration-input)
      iris:ease-(--comp-motion-easing-input)
    `,
        footerCounter: `
      iris:text-right
      iris:text-(length:--comp-type-size-input-helper)
      iris:leading-(--comp-type-leading-input-helper)
      iris:font-(--comp-type-weight-input-helper)
      iris:tracking-(--comp-type-tracking-input-helper)
      iris:text-(--comp-color-content-input-helper-default)
      iris:transition-all
      iris:duration-(--comp-motion-duration-input)
      iris:ease-(--comp-motion-easing-input)
    `,
    },
    variants: {
        variant: {
            [INPUT_VARIANT.Inner]: {
                textArea: `
          iris:pb-(--comp-space-padding-text-area-vertical)
          iris:group-data-[state=has-value]:pb-(--base-space-px-16)
        `,
                container: `
          iris:pt-(--comp-space-padding-text-area-vertical)
          iris:group-focus-within:pt-(--comp-space-padding-text-area-inner-label-filled-top)
          iris:group-data-[state=has-value]:pt-(--comp-space-padding-text-area-inner-label-filled-top)
        `,
            },
            [INPUT_VARIANT.Outer]: {
                textArea: "iris:py-(--comp-space-padding-text-area-vertical)",
            },
        },
        error: {
            true: {
                container: `
          iris:border-(--comp-color-border-input-error)
          iris:bg-(--comp-color-background-input-error)
          iris:group-hover:border-(--comp-color-border-input-error)
          iris:group-hover:bg-(--comp-color-background-input-error)
          iris:focus-within:border-(--comp-color-border-input-error)
          iris:focus-within:bg-(--comp-color-background-input-error)
        `,
                outerLabel: `
          iris:text-(--comp-color-content-input-label-error)
          iris:group-focus-within:text-(--comp-color-content-input-label-error)
          iris:group-hover:text-(--comp-color-content-input-label-error)
          iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-error)
          iris:hover:text-(--comp-color-content-input-label-error)
        `,
                innerLabel: `
          iris:text-(--comp-color-content-input-label-error)
          iris:group-focus-within:text-(--comp-color-content-input-label-error)
          iris:group-hover:text-(--comp-color-content-input-label-error)
          iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-error)
          iris:hover:text-(--comp-color-content-input-label-error)
        `,
                textArea: "iris:text-(--comp-color-content-input-value-rest)",
                footerHelper: "iris:text-(--comp-color-content-input-helper-default)",
            },
        },
        counterError: {
            true: {
                footerCounter: "iris:text-(--comp-color-content-input-helper-error)",
            },
        },
        inverse: {
            true: {
                container: `
          iris:border-(--comp-color-border-input-inverse-rest)
          iris:bg-(--comp-color-background-input-inverse-rest)
          iris:group-hover:border-(--comp-color-border-input-inverse-hover)
          iris:focus-within:border-(--comp-color-border-input-inverse-active)
          iris:focus-within:bg-(--comp-color-background-input-inverse-active)
          iris:focus-within:ring-(--sem-color-border-interactive-inverse-selected)
          iris:focus-within:ring-offset-(--sem-color-background-neutral-inverse-primary)
          iris:hover:bg-(--comp-color-background-input-inverse-hover)
        `,
                outerLabel: `
          iris:text-(--comp-color-content-input-label-inverse-rest)
          iris:group-focus-within:text-(--comp-color-content-input-label-inverse-active)
          iris:group-hover:text-(--comp-color-content-input-label-inverse-hover)
          iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-inverse-active)
        `,
                innerLabel: `
          iris:text-(--comp-color-content-input-label-inverse-rest)
          iris:group-focus-within:text-(--comp-color-content-input-label-inverse-active)
          iris:group-hover:text-(--comp-color-content-input-label-inverse-hover)
          iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-inverse-active)
        `,
                textArea: `
          iris:text-(--comp-color-content-input-value-inverse-rest)
          iris:placeholder:text-(--comp-color-content-input-placeholder-inverse-rest)
          iris:group-hover:placeholder:text-(--comp-color-content-input-placeholder-inverse-hover)
          iris:focus-within:text-(--comp-color-content-input-value-inverse-active)
          iris:hover:text-(--comp-color-content-input-value-inverse-hover)
          iris:data-[state=has-value]:text-(--comp-color-content-input-value-inverse-active)
        `,
                footerHelper: "iris:text-(--comp-color-content-input-helper-inverse-default)",
                footerCounter: "iris:text-(--comp-color-content-input-helper-inverse-default)",
            },
        },
        disabled: {
            true: {
                root: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
                container: "iris:group-hover:border-(--comp-color-border-input-rest)",
                textArea: "iris:cursor-not-allowed",
                outerLabel: "iris:cursor-not-allowed",
                innerLabel: "iris:cursor-not-allowed",
            },
        },
    },
    compoundVariants: [
        {
            inverse: true,
            error: true,
            class: {
                container: `
          iris:border-(--comp-color-border-input-inverse-error)
          iris:bg-(--comp-color-background-input-input-inverse-error)
          iris:group-hover:border-(--comp-color-border-input-inverse-error)
          iris:group-hover:bg-(--comp-color-background-input-input-inverse-error)
          iris:focus-within:border-(--comp-color-border-input-inverse-error)
          iris:focus-within:bg-(--comp-color-background-input-input-inverse-error)
        `,
                innerLabel: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:group-focus-within:text-(--comp-color-content-input-label-inverse-error)
          iris:group-hover:text-(--comp-color-content-input-label-inverse-error)
          iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
        `,
                outerLabel: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:group-focus-within:text-(--comp-color-content-input-label-inverse-error)
          iris:group-hover:text-(--comp-color-content-input-label-inverse-error)
          iris:group-focus-within:group-hover:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
        `,
                textArea: "",
                errorLabel: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
        `,
                errorIcon: "iris:text-(--comp-color-content-input-label-inverse-error)",
                footerCounter: "iris:text-(--comp-color-content-input-helper-inverse-error)",
            },
        },
        {
            inverse: false,
            error: true,
            disabled: true,
            class: {
                container: "iris:group-hover:border-(--comp-color-border-input-error)",
            },
        },
        {
            inverse: true,
            error: false,
            disabled: true,
            class: {
                container: `
          iris:group-hover:border-(--comp-color-border-input-inverse-rest)
          iris:group-hover:bg-[unset]
        `,
            },
        },
        {
            inverse: true,
            error: true,
            disabled: true,
            class: {
                container: `
          iris:group-hover:border-(--comp-color-border-input-inverse-error)
          iris:group-hover:bg-[unset]
        `,
            },
        },
    ],
});

export { textAreaStyles as default };
